export default "__VITE_ASSET__RHMd8PmP__"